import React from 'react';

import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { css, styled } from 'styled-components';

import Link from 'components/Link';

const IconContainer = styled(Link)<{ styles?: string }>(
  ({ theme, styles }) => css`
    border-radius: 50%;
    font-size: 0.875rem;
    width: 2.25rem;
    height: 2.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 250ms ease-in-out;

    &:hover {
      background-color: ${theme.colors.iconHoverGray};
    }
    ${styles}
  `
);

const StyledFaIcon = styled(FontAwesomeIcon)<{ styles?: string }>(
  ({ styles }) => css`
    ${styles}
  `
);

interface IconButtonProps {
  icon?: IconDefinition;
  children?: React.ReactNode;
  onClick?: () => void;
  to?: string;
  target?: string;
  iconStyles?: string;
  iconContainerStyles?: string;
  type?: 'button' | 'reset' | 'submit' | undefined;
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  children,
  iconStyles,
  iconContainerStyles,
  to,
  target,
  onClick,
  ...props
}) => (
  <IconContainer to={to} target={target} onClick={onClick} styles={iconContainerStyles} {...props}>
    {icon ? <StyledFaIcon aria-hidden='true' icon={icon} styles={iconStyles} /> : children}
  </IconContainer>
);

export default IconButton;
